import * as React from "react";
import { IntlProvider } from "react-intl";

import { defaultLanguage, localeStore } from "src/i18n/locale-store";
import { Consumer } from "./locale-context";

const MessageProvider: React.SFC = ({ children }) => (
  <Consumer>
    {state => {
      let locale = state.locale;

      if (!localeStore[locale]) {
        locale = defaultLanguage;
      }

      return (
        <IntlProvider locale={locale} messages={localeStore.getMessages()} textComponent={React.Fragment}>
          {children}
        </IntlProvider>
      );
    }}
  </Consumer>
);

export default MessageProvider;



// WEBPACK FOOTER //
// ./src/components/localization/message-provider.tsx